import type { SVGProps } from 'react';

const SvgUserTypeBrowse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="currentcolor" d="M16 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
    <path
      fill="currentcolor"
      d="M16 3c-3.01 0-5 2.41-5 4s1.99 4 5 4 5-2.41 5-4-1.99-4-5-4m0 6c-2 0-3-1.62-3-2s1-2 3-2 3 1.62 3 2-1 2-3 2m-2.87 5.63c.37-.5.65-1.08.78-1.72.11-.54-.24-1.07-.78-1.18s-1.07.24-1.18.78c-.24 1.16-1.27 2-2.45 2a2.5 2.5 0 0 1-2.5-2.5c0-1.23.92-2.29 2.13-2.47.55-.08.92-.59.84-1.14a.99.99 0 0 0-1.14-.84C6.65 7.89 5 9.8 5 12.01c0 .98.33 1.89.86 2.63A6.45 6.45 0 0 0 3 20.01c0 .55.45 1 1 1s1-.45 1-1c0-1.71.97-3.24 2.47-4 .61.31 1.29.5 2.03.5s1.42-.19 2.03-.5c1.51.76 2.47 2.28 2.47 4 0 .55.45 1 1 1s1-.45 1-1c0-2.21-1.1-4.18-2.87-5.37z"
    />
  </svg>
);
export default SvgUserTypeBrowse;
